import SustainabilityService from 'src/modules/sustainability/sustainabilityService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { i18n } from 'src/i18n';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'SUSTAINABILITY_FORM';

const sustainabilityFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: sustainabilityFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await SustainabilityService.find(id);
      }

      dispatch({
        type: sustainabilityFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: sustainabilityFormActions.INIT_ERROR,
      });

      navigateTo('/library/sustainability');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: sustainabilityFormActions.CREATE_STARTED,
      });

      await SustainabilityService.create(values);

      dispatch({
        type: sustainabilityFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.sustainability.create.success'));

      navigateTo('/library/sustainability');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: sustainabilityFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: sustainabilityFormActions.UPDATE_STARTED,
      });

      await SustainabilityService.update(id, values);

      dispatch({
        type: sustainabilityFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.sustainability.update.success'));

      navigateTo('/library/sustainability');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: sustainabilityFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default sustainabilityFormActions;
